import React, {createContext, useContext, useState} from 'react'

const StickyContext = createContext()

export const StickyProvider = ({children}) => {
    const [pdpStickyButtonActive, setPdpStickyButtonActive] = useState(false)

    return (
        <StickyContext.Provider
            value={{
                pdpStickyButtonActive,
                setPdpStickyButtonActive
            }}
        >
            {children}
        </StickyContext.Provider>
    )
}

export const useStickyState = () => useContext(StickyContext)
